import { call, put } from "redux-saga/effects";
import Axios from "../../utils/axios";
import {
  fetchEventTypesDone,
  fetchEventTypesError
} from "../../state/events/actions";
import { STRETCH_FETCH_EVENT_TYPES } from "../../state/events/constants";

function* fetchEventTypes() {
  try {
    const result = yield call(Axios.core.get, `${STRETCH_FETCH_EVENT_TYPES}`);
    const data = result.data ? result.data : [];
    yield put(fetchEventTypesDone(data));
  } catch (e) {
    yield put(fetchEventTypesError(e));
  }
}

export default fetchEventTypes;
